module.exports = __webpack_public_path__ + "img/Google_Partner.73185adc.png";